(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aeris-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aeris-immersive-hero')) {
    customElements.define('aeris-immersive-hero', class extends HTMLElement {
      connectedCallback() {
        if (this.lifecycle) return;
        this.lifecycle = new AbortController();
        const signal = this.lifecycle.signal;
        this.media = this.querySelector('[data-hero-media]');
        this.template = this.querySelector('[data-hero-video]');
        this.inlineVideo = this.media?.querySelector('video');
        this.content = this.querySelector('[data-hero-content]');
        this.controls = this.querySelector('[data-hero-controls]');
        this.playButton = this.querySelector('[data-hero-play]');
        this.soundButton = this.querySelector('[data-hero-sound]');
        this.mobile = matchMedia('(max-width: 749px)');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.inView = false;
        this.pageActive = true;
        this.userPaused = false;
        this.userStarted = false;
        this.soundMuted = true;
        this.revealed = false;
        this.buffering = false;
        this.playing = false;
        this.pauseExpected = false;
        this.autoAttempts = 0;
        this.autoplayBlocked = false;
        this.pendingPlay = null;
        this.attemptId = 0;
        this.dataset.playbackState = 'idle';
        delete this.dataset.playbackError;
        this.editorSelected = this.dataset.designMode === 'true';
        this.playButton?.addEventListener('click', () => {
          if (this.video && !this.video.paused) {
            this.userPaused = true;
            this.stopPlayback();
            this.syncControls();
          } else {
            this.userPaused = false;
            this.userStarted = true;
            this.inView = this.mediaVisible();
            this.requestPlayback(true);
          }
        }, { signal });
        this.soundButton?.addEventListener('click', () => {
          if (!this.video) return;
          this.video.muted = !this.video.muted;
          this.soundMuted = this.video.muted;
          this.syncControls();
        }, { signal });
        this.content?.addEventListener('focusin', () => this.showCopy(), { signal });
        this.mobile.addEventListener('change', () => this.refreshEnvironment(), { signal });
        this.motion.addEventListener('change', () => this.updateCopy(), { signal });
        document.addEventListener('visibilitychange', () => this.refreshEnvironment(), { signal });
        window.addEventListener('pageshow', () => {
          this.pageActive = true;
          this.refreshEnvironment();
        }, { signal });
        window.addEventListener('pagehide', () => {
          this.pageActive = false;
          this.stopPlayback();
        }, { signal });
        window.addEventListener('resize', () => this.refreshEnvironment(), { signal });
        document.addEventListener('shopify:section:select', event => {
          if (event.detail?.sectionId !== this.dataset.sectionId) return;
          this.editorSelected = true;
          this.showCopy();
        }, { signal });
        document.addEventListener('shopify:section:deselect', event => {
          if (event.detail?.sectionId !== this.dataset.sectionId) return;
          this.editorSelected = false;
          this.updateCopy();
        }, { signal });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(() => this.refreshEnvironment(), { threshold: [0, .1] });
          this.observer.observe(this.media);
        } else {
          window.addEventListener('scroll', () => this.refreshEnvironment(), { signal, passive: true });
        }
        this.showCopy();
        this.refreshEnvironment();
      }
      mediaVisible() {
        if (!this.media) return false;
        const rect = this.media.getBoundingClientRect();
        const height = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
        const width = Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0);
        return rect.width > 0 && rect.height > 0 && width > 0 && height > 0 && width * height / (rect.width * rect.height) >= .1;
      }
      refreshEnvironment() {
        const visible = this.mediaVisible();
        if (visible && !this.inView && !this.autoplayBlocked) this.autoAttempts = 0;
        this.inView = visible;
        this.environmentChanged();
      }
      videoAllowed() {
        return Boolean(this.template || this.inlineVideo) && !(this.mobile.matches && this.dataset.mobilePhoto === 'true');
      }
      automaticPlaybackAllowed() {
        return !this.userPaused && (this.dataset.autoplay !== 'false' || this.userStarted);
      }
      canPlayAutomatically() {
        return this.isConnected && this.pageActive && !document.hidden && this.inView && this.videoAllowed() && this.automaticPlaybackAllowed();
      }
      ensureVideo() {
        if (this.video || !this.videoAllowed()) return;
        const video = this.inlineVideo || this.template?.content.querySelector('video')?.cloneNode(true);
        if (!video) return;
        this.video = video;
        this.videoEvents = new AbortController();
        const signal = this.videoEvents.signal;
        video.autoplay = false;
        video.defaultMuted = true;
        video.muted = this.soundMuted;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.preload = this.canPlayAutomatically() ? 'auto' : 'metadata';
        video.addEventListener('playing', () => this.didStartPlaying(video), { signal });
        video.addEventListener('play', () => this.syncControls(), { signal });
        video.addEventListener('pause', () => {
          if (this.video !== video || !video.paused) return;
          const wasPlaying = this.playing;
          const expected = this.pauseExpected;
          this.pauseExpected = false;
          this.playing = false;
          this.dataset.playbackState = 'paused';
          this.showCopy();
          this.syncControls();
          if (expected) return;
          if (wasPlaying) {
            this.userPaused = true;
            this.cancelPlaybackRetry();
          } else if (!this.pendingPlay) {
            this.schedulePlayback(350);
          }
        }, { signal });
        video.addEventListener('timeupdate', () => this.updateCopy(), { signal });
        video.addEventListener('loadedmetadata', () => this.updateCopy(), { signal });
        ['loadeddata', 'canplay'].forEach(name => video.addEventListener(name, () => this.schedulePlayback(), { signal }));
        video.addEventListener('volumechange', () => {
          this.soundMuted = video.muted;
          this.syncControls();
        }, { signal });
        ['waiting', 'stalled'].forEach(name => video.addEventListener(name, () => {
          this.buffering = true;
          this.showCopy();
        }, { signal }));
        video.addEventListener('error', () => {
          this.stopPlayback();
          this.autoplayBlocked = true;
          this.dataset.playbackState = 'error';
          this.dataset.playbackError = 'MediaError:' + (video.error?.code || 0);
          this.buffering = false;
          this.classList.remove('has-played');
          this.showCopy();
          this.syncControls();
        }, { signal });
        video.addEventListener('ended', () => {
          this.playing = false;
          this.showCopy();
          this.syncControls();
        }, { signal });
        if (!this.inlineVideo) this.media.prepend(video);
        this.controls.hidden = false;
        this.classList.add('is-enhanced');
        video.controls = false;
        this.syncControls();
      }
      didStartPlaying(video) {
        if (this.video !== video) return;
        if (!this.canPlayAutomatically()) {
          this.stopPlayback();
          return;
        }
        this.cancelPlaybackRetry();
        this.cancelPlayAttempt();
        this.playing = true;
        this.pauseExpected = false;
        this.autoAttempts = 0;
        this.autoplayBlocked = false;
        this.dataset.playbackState = 'playing';
        delete this.dataset.playbackError;
        this.buffering = false;
        this.classList.add('has-played');
        this.updateCopy();
        this.syncControls();
      }
      cancelPlaybackRetry() {
        clearTimeout(this.retryTimer);
        this.retryTimer = null;
      }
      cancelPlayAttempt() {
        clearTimeout(this.playWatchdog);
        this.playWatchdog = null;
        this.pendingPlay = null;
        this.attemptId += 1;
      }
      stopPlayback() {
        this.cancelPlaybackRetry();
        this.cancelPlayAttempt();
        this.playing = false;
        if (this.video) {
          this.video.autoplay = false;
          if (!this.video.paused) {
            this.pauseExpected = true;
            this.video.pause();
          }
        }
        this.showCopy();
      }
      releaseVideo() {
        this.stopPlayback();
        if (!this.video) return;
        const video = this.video;
        this.videoEvents?.abort();
        if (video !== this.inlineVideo) {
          video.removeAttribute('src');
          video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
          video.load();
          video.remove();
        } else {
          video.controls = true;
        }
        this.video = null;
        this.autoAttempts = 0;
        this.autoplayBlocked = false;
        this.controls.hidden = true;
        this.classList.remove('has-played', 'is-enhanced');
        this.showCopy();
      }
      environmentChanged() {
        if (!this.videoAllowed()) {
          this.releaseVideo();
          return;
        }
        this.ensureVideo();
        if (!this.canPlayAutomatically()) {
          this.stopPlayback();
          return;
        }
        this.requestPlayback();
        this.updateCopy();
      }
      schedulePlayback(delay = 0) {
        if (!this.canPlayAutomatically() || this.autoplayBlocked || this.autoAttempts >= 3 || this.pendingPlay || this.retryTimer != null || this.playing) return;
        this.retryTimer = setTimeout(() => {
          this.retryTimer = null;
          this.requestPlayback();
        }, delay);
      }
      requestPlayback(explicit = false) {
        if (!this.canPlayAutomatically()) return;
        if (explicit) {
          this.cancelPlaybackRetry();
          this.cancelPlayAttempt();
          this.autoplayBlocked = false;
          this.autoAttempts = 0;
        } else if (this.autoplayBlocked || this.autoAttempts >= 3 || this.pendingPlay || this.playing) return;
        this.ensureVideo();
        const video = this.video;
        if (!video) return;
        if (!explicit) this.autoAttempts += 1;
        this.pauseExpected = false;
        video.preload = 'auto';
        video.autoplay = !explicit;
        this.dataset.playbackState = 'starting';
        const attempt = { id: ++this.attemptId, video, explicit };
        this.pendingPlay = attempt;
        if (!explicit) {
          this.playWatchdog = setTimeout(() => {
            if (this.pendingPlay !== attempt || this.video !== video || this.playing) return;
            this.stopPlayback();
            this.dataset.playbackState = 'waiting';
            this.dataset.playbackError = 'StartTimeout';
            this.schedulePlayback(350);
          }, 10000);
        }
        let result;
        try {
          result = video.play();
        } catch (error) {
          result = Promise.reject(error);
        }
        Promise.resolve(result).then(() => {
          if (this.pendingPlay !== attempt || this.video !== video) return;
          if (!video.paused) this.didStartPlaying(video);
        }).catch(error => {
          if (this.pendingPlay !== attempt || this.video !== video) return;
          this.cancelPlayAttempt();
          const reason = error?.name || 'PlaybackError';
          this.dataset.playbackError = reason;
          this.dataset.playbackState = reason === 'NotAllowedError' ? 'blocked' : 'error';
          this.autoplayBlocked = reason !== 'AbortError';
          video.autoplay = false;
          this.showCopy();
          this.syncControls();
          if (reason === 'AbortError') this.schedulePlayback(350);
        });
      }
      showCopy() {
        this.classList.remove('is-copy-waiting');
        if (this.content) this.content.inert = false;
      }
      updateCopy() {
        const video = this.video;
        if (!video || video.paused || video.ended || video.error || this.buffering || !this.classList.contains('has-played') || this.motion.matches || this.editorSelected || this.dataset.appearance !== 'delay' || (this.mobile.matches && this.dataset.mobileLayout === 'below') || this.content.contains(document.activeElement)) {
          this.showCopy();
          return;
        }
        let delay = Math.max(0, Number(this.dataset.delay) || 0);
        if (Number.isFinite(video.duration) && video.duration > 0) delay = Math.min(delay, video.duration * .65);
        if (video.currentTime >= delay) this.revealed = true;
        const visible = video.currentTime >= delay || (this.revealed && this.dataset.repeat !== 'true');
        this.classList.toggle('is-copy-waiting', !visible);
        this.content.inert = !visible;
      }
      syncControls() {
        if (!this.video || !this.playButton) return;
        const paused = this.video.paused || this.video.ended;
        const label = paused ? this.playButton.dataset.play : this.playButton.dataset.pause;
        this.playButton.setAttribute('aria-label', label);
        this.playButton.title = label;
        this.playButton.querySelector('[data-play-icon]').toggleAttribute('hidden', !paused);
        this.playButton.querySelector('[data-pause-icon]').toggleAttribute('hidden', paused);
        if (!this.soundButton) return;
        const muted = this.video.muted || this.video.volume === 0;
        const soundLabel = muted ? this.soundButton.dataset.unmute : this.soundButton.dataset.mute;
        this.soundButton.setAttribute('aria-label', soundLabel);
        this.soundButton.title = soundLabel;
        this.soundButton.querySelector('[data-muted-icon]').toggleAttribute('hidden', !muted);
        this.soundButton.querySelector('[data-sound-icon]').toggleAttribute('hidden', muted);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.lifecycle?.abort();
        this.releaseVideo();
        this.lifecycle = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aeris-offer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aeris-offer')) {
    class AerisOffer extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.buttons = Array.from(this.querySelectorAll('[data-offer-color]'));
        this.discover = this.querySelector('[data-offer-discover]');
        this.stage = this.querySelector('[data-diptych-stage]');
        this.handle = this.querySelector('[data-diptych-divider]');
        this.seam = this.querySelector('[data-diptych-seam]');
        this.panels = Array.from(this.querySelectorAll('[data-diptych-panel]'));
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.split = Number.isFinite(this.split) ? this.split : 50;
        this.choice = this.choice || (this.stage ? 'duo' : this.dataset.selectedColor || 'black');
        this.request = 0;
        this.dragging = null;
        this.buttons.forEach((button) => {
          button.disabled = false;
          button.addEventListener('click', () => this.selectColor(button), options);
        });
        if (!this.stage || !this.handle) return;
        this.dataset.diptychReady = '';
        this.handle.hidden = false;
        this.paint();
        this.handle.addEventListener('pointerdown', (event) => {
          if (event.button !== 0 || this.dragging) return;
          this.cancelAnimation();
          this.dragging = { id: event.pointerId, x: event.clientX, split: this.split };
          this.handle.setPointerCapture(event.pointerId);
        }, options);
        this.handle.addEventListener('pointermove', (event) => {
          if (!this.dragging || event.pointerId !== this.dragging.id) return;
          const width = Math.max(1, this.stage.getBoundingClientRect().width - 44);
          this.choice = 'manual';
          this.move(this.dragging.split + (event.clientX - this.dragging.x) * 100 / width, false);
        }, options);
        this.handle.addEventListener('pointerup', (event) => this.endDrag(event), options);
        this.handle.addEventListener('pointercancel', (event) => this.endDrag(event), options);
        this.handle.addEventListener('lostpointercapture', (event) => this.endDrag(event), options);
        this.handle.addEventListener('dblclick', () => this.selectColor(this.buttons.find((button) => button.dataset.offerColor === 'duo')), options);
        this.handle.addEventListener('keydown', (event) => {
          let target = this.split;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') target -= 2;
          else if (event.key === 'ArrowRight' || event.key === 'ArrowUp') target += 2;
          else if (event.key === 'Home') target = 0;
          else if (event.key === 'End') target = 100;
          else if (event.key === 'Enter' || event.key === ' ') target = 50;
          else return;
          event.preventDefault();
          if (this.dragging) {
            const id = this.dragging.id;
            this.dragging = null;
            if (this.handle.hasPointerCapture(id)) this.handle.releasePointerCapture(id);
          }
          target = this.clamp(target);
          this.choice = target === 50 ? 'duo' : target > 50 ? 'black' : 'white';
          this.commitColor(this.choice);
          this.move(target, false);
        }, options);
        this.motion.addEventListener('change', () => {
          if (this.reduceMotion() && this.request) this.move(this.targetSplit, false);
        }, options);
      }

      disconnectedCallback() {
        this.events?.abort();
        this.events = null;
        this.cancelAnimation();
        if (this.dragging && this.handle?.hasPointerCapture(this.dragging.id)) this.handle.releasePointerCapture(this.dragging.id);
        this.dragging = null;
      }

      clamp(value) {
        return Number.isFinite(value) ? Math.max(0, Math.min(100, value)) : 50;
      }

      reduceMotion() {
        return this.dataset.motion === 'none' || (this.dataset.motion === 'system' && this.motion.matches);
      }

      commitColor(color) {
        if (!['black', 'white'].includes(color)) return;
        const button = this.buttons.find((item) => item.dataset.offerColor === color);
        this.dataset.selectedColor = color;
        if (this.discover && button?.dataset.variantUrl) this.discover.setAttribute('href', button.dataset.variantUrl);
        this.dispatchEvent(new CustomEvent('aeris:variant-change', {
          detail: { variant: { options: [color] } }
        }));
      }

      selectColor(button) {
        const color = button?.dataset.offerColor;
        if (!['black', 'white', 'duo'].includes(color) || (color === 'duo' && !this.stage)) return;
        if (this.dragging) {
          const id = this.dragging.id;
          this.dragging = null;
          if (this.handle.hasPointerCapture(id)) this.handle.releasePointerCapture(id);
        }
        this.choice = color;
        this.commitColor(color);
        if (this.stage) this.move(color === 'black' ? 100 : color === 'white' ? 0 : 50, true);
        else this.paintButtons();
      }

      paintButtons() {
        this.buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.offerColor === this.choice)));
        this.dataset.view = this.choice;
      }

      paint() {
        this.paintButtons();
        if (!this.stage || !this.handle) return;
        this.stage.style.setProperty('--aeris-split', this.split + '%');
        this.handle.style.left = 'calc(' + this.split + '% + ' + (22 - .44 * this.split) + 'px)';
        if (this.seam) this.seam.style.opacity = this.split <= .01 || this.split >= 99.99 ? '0' : '1';
        this.panels.forEach((panel) => {
          const share = panel.dataset.diptychPanel === 'black' ? this.split : 100 - this.split;
          panel.setAttribute('aria-hidden', String(share <= .01));
        });
        this.handle.setAttribute('aria-valuenow', String(Math.round(this.split)));
        this.handle.setAttribute('aria-valuetext', this.dataset.blackLabel + ' ' + Math.round(this.split) + ' %, ' + this.dataset.whiteLabel + ' ' + Math.round(100 - this.split) + ' %');
      }

      move(value, animate) {
        this.cancelAnimation();
        const target = this.clamp(value);
        this.targetSplit = target;
        this.paintButtons();
        if (!animate || this.reduceMotion() || Math.abs(target - this.split) < .001) {
          this.split = target;
          this.paint();
          return;
        }
        const from = this.split;
        const duration = Math.max(800, Math.min(1800, Number(this.dataset.duration) || 1200));
        let began = null;
        const tick = (now) => {
          if (began === null) began = now;
          const t = Math.min(1, (now - began) / duration);
          this.split = from + (target - from) * t * t * (3 - 2 * t);
          this.paint();
          if (t < 1) this.request = requestAnimationFrame(tick);
          else this.request = 0;
        };
        this.request = requestAnimationFrame(tick);
      }

      endDrag(event) {
        if (!this.dragging || event.pointerId !== this.dragging.id) return;
        this.dragging = null;
        if (Math.abs(this.split - 50) < 2) {
          this.choice = 'duo';
          this.move(50, true);
        } else {
          this.choice = this.split > 50 ? 'black' : 'white';
          this.commitColor(this.choice);
          this.paint();
        }
        if (this.handle.hasPointerCapture(event.pointerId)) this.handle.releasePointerCapture(event.pointerId);
      }

      cancelAnimation() {
        if (this.request) cancelAnimationFrame(this.request);
        this.request = 0;
      }
    }
    customElements.define('aeris-offer', AerisOffer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aeris-product"]) return;
  try {
    
  if (!customElements.get('aeris-product')) {
    customElements.define('aeris-product', class extends HTMLElement {
      static capsuleDismissed = false;
      static capsuleSeen = false;

      connectedCallback() {
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.form = this.querySelector('form[action*="/cart/add"]');
        this.select = this.querySelector('[data-variant-select]');
        this.variants = JSON.parse(this.querySelector('[data-aeris-variants]').textContent);
        if (!this.variants.length) return;
        this.buildOptions();
        this.options = [...this.querySelectorAll('[data-option-index]')];
        this.mainBuy = this.querySelector('[data-main-buy]');
        this.sticky = this.querySelector('[data-sticky]');
        this.error = this.querySelector('[data-error]');
        this.slides = this.querySelector('[data-slides]');
        this.allThumbs = [...this.querySelectorAll('[data-thumbnail]')];
        this.allMedia = [...this.querySelectorAll('[data-media-id]')];
        this.thumbnails = this.querySelector('[data-thumbnails]');
        this.media = [];
        this.thumbs = [];
        this.galleryColor = null;
        this.activeIndex = 0;
        this.busy = false;
        this.querySelector('[data-options]').hidden = false;
        this.querySelector('[data-fallback]').hidden = true;
        this.addEventListener('change', event => {
          if (event.target.closest('[data-option-index]')) this.setVariant();
        }, { signal });
        this.form.addEventListener('submit', event => this.addToCart(event), { signal });
        this.allThumbs.forEach(thumb => thumb.addEventListener('click', event => {
          event.preventDefault();
          this.showMedia(this.media.findIndex(media => media.dataset.mediaId === thumb.dataset.mediaKey));
        }, { signal }));
        this.slides?.addEventListener('scroll', () => {
          if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => {
            const index = Math.max(0, Math.min(this.media.length - 1, Math.round(this.slides.scrollLeft / Math.max(1, this.slides.clientWidth))));
            this.activeIndex = index;
            this.thumbs.forEach((thumb, i) => i === index ? thumb.setAttribute('aria-current', 'true') : thumb.removeAttribute('aria-current'));
          });
        }, { signal, passive: true });
        if (this.sticky && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            const entry = entries[0];
            this.sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
          });
          this.observer.observe(this.mainBuy);
        }
        this.onPopState = () => {
          const variant = this.variantFromUrl();
          this.options.forEach((field, index) => field.querySelectorAll('input').forEach(input => { input.checked = input.value === variant.options[index]; }));
          this.setVariant(false);
          const requestedId = new URL(window.location.href).searchParams.get('variant');
          if (requestedId && requestedId !== String(variant.id)) this.updateVariantUrl();
        };
        window.addEventListener('popstate', this.onPopState, { signal });
        this.onPopState();
        this.initArCapsule();
        if (this.dataset.designMode === 'true') this.addEventListener('shopify:block:select', event => this.selectGalleryBlock(event), { signal });
        if (this.slides && 'ResizeObserver' in window) {
          this.galleryObserver = new ResizeObserver(() => this.showMedia(this.activeIndex, 'instant'));
          this.galleryObserver.observe(this.slides);
        }
      }
      updateVariantUrl() {
        const url = new URL(window.location.href);
        url.pathname = new URL(this.variant.url, window.location.origin).pathname;
        url.searchParams.set('variant', this.variant.id);
        history.replaceState({}, '', url);
      }
      variantFromUrl() {
        const url = new URL(window.location.href);
        const id = url.searchParams.get('variant');
        const explicit = this.variants.find(item => String(item.id) === id);
        if (explicit) return explicit;
        const legacyColor = { '54805316698450': 'black', '54805316763986': 'white' }[id];
        if (legacyColor) {
          const replacement = this.variants.find(item => item.configuration === 'pair' && this.normalizeGalleryColor(item.options[0]) === legacyColor);
          if (replacement) return replacement;
        }
        return this.variants.find(item => String(item.id) === this.dataset.currentVariantId)
          || this.variants.find(item => new URL(item.url, window.location.origin).pathname === url.pathname)
          || this.variants[0];
      }
      buildOptions() {
        const container = this.querySelector('[data-options]');
        const fragment = document.createDocumentFragment();
        [0, 1].forEach(index => {
          const field = document.createElement('fieldset');
          field.className = 'aeris-product__option' + (index === 0 ? ' aeris-product__option--color' : '');
          field.dataset.optionIndex = String(index);
          if (index === 0) field.dataset.colorOption = 'true';
          const legend = document.createElement('legend');
          legend.textContent = index === 0 ? this.dataset.colorLabel + ' : ' : this.dataset.configurationLabel;
          if (index === 0) {
            const colorLabel = document.createElement('span');
            colorLabel.dataset.colorLabel = '';
            legend.append(colorLabel);
          }
          field.append(legend);
          const values = document.createElement('div');
          values.className = 'aeris-product__option-values';
          [...new Set(this.variants.map(variant => variant.options[index]))].forEach((value, choiceIndex) => {
            const choice = document.createElement('div');
            choice.className = 'aeris-product__choice';
            const input = document.createElement('input');
            input.type = 'radio';
            input.id = 'AerisOption-' + this.dataset.sectionId + '-' + index + '-' + choiceIndex;
            input.name = 'aeris-option-' + this.dataset.sectionId + '-' + index;
            input.value = value;
            const label = document.createElement('label');
            label.htmlFor = input.id;
            if (index === 0) {
              const swatch = document.createElement('span');
              swatch.className = 'aeris-product__swatch' + (this.normalizeGalleryColor(value) === 'white' ? ' aeris-product__swatch--white' : '');
              swatch.setAttribute('aria-hidden', 'true');
              label.append(swatch);
            }
            const caption = document.createElement('span');
            caption.textContent = index === 0 ? value : value === 'pair' ? this.dataset.pairLabel : this.dataset.singleLabel;
            label.append(caption);
            if (index === 1) {
              const price = document.createElement('span');
              price.className = 'aeris-product__option-price';
              price.dataset.optionPrice = '';
              label.append(price);
            }
            choice.append(input, label);
            values.append(choice);
          });
          field.append(values);
          fragment.append(field);
        });
        container.replaceChildren(fragment);
        this.select.replaceChildren(...this.variants.map(variant => new Option(variant.title, String(variant.id))));
      }
      async initArCapsule() {
        const capsule = this.querySelector('[data-ar-capsule]');
        const viewer = this.querySelector('aeris-ar-viewer');
        if (!capsule || !viewer) return;
        capsule.hidden = true;
        capsule.classList.remove('is-new');
        const signal = this.abort.signal;
        await customElements.whenDefined('aeris-ar-viewer');
        if (signal.aborted || !this.isConnected || typeof viewer.open !== 'function') return;
        const openButton = capsule.querySelector('[data-ar-capsule-open]');
        const dismissButton = capsule.querySelector('[data-ar-capsule-dismiss]');
        const existingButton = viewer.querySelector('[data-ar-open]');
        const designMode = this.dataset.designMode === 'true';
        const dismissedKey = 'aeris:ar-capsule:dismissed:v1';
        const seenKey = 'aeris:ar-capsule:seen:v1';
        let dismissed = this.constructor.capsuleDismissed;
        let seen = this.constructor.capsuleSeen;
        try {
          dismissed ||= window.sessionStorage.getItem(dismissedKey) === '1';
          seen ||= window.sessionStorage.getItem(seenKey) === '1';
        } catch {}
        openButton.addEventListener('click', () => {
          openButton.focus({ preventScroll: true });
          viewer.open();
        }, { signal });
        dismissButton.addEventListener('click', () => {
          capsule.hidden = true;
          if (!designMode) {
            this.constructor.capsuleDismissed = true;
            try { window.sessionStorage.setItem(dismissedKey, '1'); } catch {}
          }
          existingButton?.focus({ preventScroll: true });
        }, { signal });
        if (dismissed && !designMode) return;
        capsule.hidden = false;
        if (!seen && !designMode) {
          capsule.classList.add('is-new');
          this.constructor.capsuleSeen = true;
          try { window.sessionStorage.setItem(seenKey, '1'); } catch {}
        }
      }
      normalizeGalleryColor(value) {
        const color = String(value || '').trim().toLowerCase();
        return color === 'black' || color === 'noir' ? 'black' : color === 'white' || color === 'blanc' ? 'white' : '';
      }
      updateGallery() {
        if (!this.allMedia) return;
        const colorField = this.options.find(field => field.dataset.colorOption === 'true');
        const color = this.normalizeGalleryColor(colorField?.querySelector('input:checked')?.value);
        if (this.galleryColor === color) return;
        this.galleryColor = color;
        const hasColor = Boolean(color) && this.allMedia.some(media => media.dataset.galleryGroup === color);
        this.media = this.allMedia.filter(media => {
          const group = media.dataset.galleryGroup;
          const visible = group === 'common' || (hasColor ? group === color : group === 'fallback');
          media.hidden = !visible;
          media.classList.remove('aeris-product__slide--ar');
          return visible;
        });
        this.thumbs = [];
        this.allThumbs.forEach(thumb => {
          const index = this.media.findIndex(media => media.dataset.mediaId === thumb.dataset.mediaKey);
          thumb.hidden = index < 0;
          thumb.removeAttribute('aria-current');
          if (index >= 0) {
            thumb.setAttribute('aria-label', this.dataset.galleryImageLabel.replace('__NUMBER__', String(index + 1)));
            this.thumbs.push(thumb);
          }
        });
        if (this.thumbnails) this.thumbnails.hidden = this.media.length < 2;
        const capsule = this.querySelector('[data-ar-capsule]');
        if (capsule && this.media[0]) {
          this.media[0].append(capsule);
          this.media[0].classList.add('aeris-product__slide--ar');
        }
        const featured = !hasColor ? this.media.findIndex(media => media.dataset.mediaId === String(this.variant?.mediaId)) : -1;
        this.showMedia(Math.max(0, featured), 'instant');
      }
      selectGalleryBlock(event) {
        const media = this.allMedia.find(item => item.dataset.blockId === event.detail?.blockId);
        if (!media) return;
        const color = media.dataset.galleryGroup;
        if (color === 'black' || color === 'white') {
          const field = this.options.find(item => item.dataset.colorOption === 'true');
          const inputs = field ? [...field.querySelectorAll('input')] : [];
          const selected = inputs.find(input => this.normalizeGalleryColor(input.value) === color);
          if (!selected) return;
          inputs.forEach(input => { input.checked = input === selected; });
          this.setVariant(false);
        }
        this.showMedia(this.media.indexOf(media), 'instant');
      }
      showMedia(index, behavior) {
        if (!this.slides || !this.media[index]) return;
        this.activeIndex = index;
        this.thumbs.forEach((thumb, i) => i === index ? thumb.setAttribute('aria-current', 'true') : thumb.removeAttribute('aria-current'));
        this.slides.scrollTo({ left: index * this.slides.clientWidth, behavior: behavior || (window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth') });
      }
      setVariant(updateUrl = true) {
        const values = this.options.map(field => field.querySelector('input:checked')?.value);
        this.variant = this.variants.find(variant => variant.options.every((value, index) => value === values[index]));
        const available = Boolean(this.variant?.available);
        this.select.value = this.variant ? String(this.variant.id) : '';
        if (this.variant) {
          const productInput = this.form.querySelector('input[name="product-id"]');
          if (productInput) productInput.value = String(this.variant.productId);
          if (this.activeProductId !== this.variant.productId) {
            this.querySelectorAll('[data-product-title]').forEach(node => { node.textContent = this.variant.productTitle; });
            this.querySelector('[data-product-heading]')?.classList.toggle('aeris-product__name--long', this.variant.productTitle.length > 10);
            const description = this.querySelector('[data-product-description]');
            const descriptionTemplate = this.querySelector('[data-product-description-template="' + this.variant.productId + '"]');
            if (description && descriptionTemplate) description.replaceChildren(descriptionTemplate.content.cloneNode(true));
            this.activeProductId = this.variant.productId;
          }
          this.querySelectorAll('[data-price]').forEach(node => { node.innerHTML = this.variant.formattedPrice; });
          this.querySelectorAll('[data-sticky-options]').forEach(node => { node.textContent = this.variant.title; });
          if (updateUrl) {
            this.updateVariantUrl();
          }
          this.updateGallery();
        }
        this.options.forEach((field, index) => {
          const colorLabel = field.querySelector('[data-color-label]');
          if (colorLabel) colorLabel.textContent = values[index] || '';
          field.querySelectorAll('.aeris-product__choice').forEach(choice => {
            const input = choice.querySelector('input');
            const candidate = this.variants.find(variant => variant.options.every((value, i) => value === (i === index ? input.value : values[i])));
            const price = choice.querySelector('[data-option-price]');
            if (price && candidate) price.innerHTML = candidate.formattedPrice;
            input.disabled = !candidate;
          });
        });
        const availability = this.querySelector('[data-availability]');
        const madeToOrder = available && this.variant.inventoryManagement && this.variant.inventoryQuantity <= 0 && this.variant.inventoryPolicy === 'continue';
        const inStock = available && this.variant.inventoryManagement && this.variant.inventoryQuantity > 0;
        availability.hidden = false;
        availability.textContent = !available ? this.dataset.unavailableLabel : madeToOrder ? this.dataset.madeToOrderLabel : inStock ? this.dataset.inStockLabel : this.dataset.availableLabel;
        this.querySelector('[data-dispatch-note]').hidden = !available;
        this.querySelectorAll('[data-main-buy], [data-sticky-buy]').forEach(button => {
          button.disabled = !available || this.busy;
          button.textContent = this.busy ? this.dataset.addingLabel : this.dataset.addLabel;
        });
        this.error.hidden = true;
        this.dispatchEvent(new CustomEvent('aeris:variant-change', { detail: { variant: this.variant } }));
      }
      async addToCart(event) {
        event.preventDefault();
        if (this.busy || !this.variant?.available) return;
        this.busy = true;
        this.setVariant(false);
        const formData = new FormData(this.form);
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const sections = cart?.getSectionsToRender?.().map(section => section.id) || [];
        if (sections.length) {
          formData.append('sections', sections.join(','));
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement?.(document.activeElement);
        }
        let added = false;
        let errorMessage = '';
        try {
          const response = await fetch(this.dataset.cartAddUrl + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: formData });
          const data = await response.json();
          if (!response.ok || data.status) {
            const status = Number(data.status || response.status);
            const businessError = status >= 400 && status < 500 && status !== 429;
            errorMessage = businessError && typeof data.description === 'string' && data.description.trim() ? data.description : this.dataset.errorLabel;
            return;
          }
          added = true;
          if (cart?.renderContents && sections.every(id => typeof data.sections?.[id] === 'string')) {
            cart.classList.remove('is-empty');
            cart.renderContents(data);
          } else {
            window.location.assign(this.dataset.cartUrl);
          }
        } catch {
          if (added) window.location.assign(this.dataset.cartUrl);
          else errorMessage = this.dataset.errorLabel;
        } finally {
          this.busy = false;
          this.setVariant(false);
          if (errorMessage) {
            this.error.textContent = errorMessage;
            this.error.hidden = false;
            this.querySelector('[data-cart-check]').hidden = false;
          }
        }
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.galleryObserver?.disconnect();
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aeris-service-page"] && !Shopify.designMode) return;
  try {
    
  function initializeAerisServicePages() {
    document.querySelectorAll('.aeris-service').forEach((section) => {
      const subject = section.querySelector('[data-aeris-contact-subject]');
      const params = new URLSearchParams(window.location.search);
      if (subject && !subject.value && params.get('subject') === 'retour') {
        const option = subject.querySelector('[data-aeris-return-option]');
        if (option) subject.value = option.value;
      }
      if (window.location.hash === '#aeris-delivery') {
        const delivery = section.querySelector('#aeris-delivery');
        if (delivery) delivery.open = true;
      }
    });
  }
  initializeAerisServicePages();
  document.addEventListener('shopify:section:load', initializeAerisServicePages);
  window.addEventListener('hashchange', initializeAerisServicePages);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.aerisOverlay = this.hasAttribute('data-aeris-overlay');
      this.headerIsAlwaysSticky =
        this.aerisOverlay ||
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.headerResizeObserver = new ResizeObserver(this.setHeaderHeight);
      this.headerResizeObserver.observe(this.header);
      this.syncOverlay = () => {
        if (!this.aerisOverlay) return;
        const menuOpen = this.header.classList.contains('menu-open') ||
          [...this.querySelectorAll('details[open]')].length > 0;
        this.classList.toggle('aeris-header--solid', window.scrollY > 16 || menuOpen);
      };
      this.syncOverlay();
      this.addEventListener('toggle', this.syncOverlay, true);
      this.headerStateObserver = new MutationObserver(this.syncOverlay);
      this.headerStateObserver.observe(this.header, { attributes: true, attributeFilter: ['class'] });
      window.addEventListener('pageshow', this.syncOverlay);

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.headerResizeObserver.disconnect();
      this.headerStateObserver.disconnect();
      this.removeEventListener('toggle', this.syncOverlay, true);
      window.removeEventListener('pageshow', this.syncOverlay);
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.syncOverlay();

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
